import React from 'react';

// eslint-disable-next-line
export default class TimeDisplay extends React.Component<{ ms: number }> {
  render() {
    const { ms } = this.props;
    const hS = Math.floor(ms / 3600 / 1000);
    const mS = Math.floor(ms / 60 / 1000) - hS * 60;
    const sS = Math.floor(ms / 1000) - mS * 60 - hS * 3600;
    return (
      <span>
        {hS > 0 && <>{hS > 9 ? hS : `0${hS}`}h</>}
        {mS > 9 ? mS : `0${mS}`}m{hS === 0 && <>{sS > 9 ? sS : `0${sS}`}</>}
      </span>
    );
  }
}
